/**
 * The one-time bootstrap store created by `apps/api/scripts/backfill-storeid.ts` to own every
 * row that predates multi-tenancy — Giftsay's own storefront. A fixed, predictable Firestore doc
 * id (rather than a random UUID) so it can be referenced as a constant: the API falls back to it
 * for unknown hosts and for staff-managed settings, and the admin portal preselects it wherever a
 * screen needs exactly one store.
 */
export const DEFAULT_STORE_ID = 'giftsay-main';

/** Every other store's storefront is its custom domain, or else its `{slug}.giftsay.in` subdomain. */
export function storefrontHost(
  storeId: string,
  slug: string,
  customDomain: string | null = null,
): string {
  if (storeId === DEFAULT_STORE_ID) return 'giftsay.in';
  return customDomain ?? `${slug}.giftsay.in`;
}

/** `orderSignals` doc id that collects every store's new orders, for platform staff. Can't
 *  collide with a store id — those never start with an underscore. */
export const PLATFORM_ORDER_SIGNAL_ID = '_platform';

/**
 * Request header the storefront sets to its own `window.location.hostname` on every API call.
 * The API resolves the store from it ahead of the proxied host: behind Firebase Hosting the
 * forwarded host occasionally names a different domain than the one the shopper is on (e.g. a
 * reused HTTP/2 connection to giftsay.in), which would silently serve Giftsay's own catalog on
 * a vendor's subdomain until a refresh.
 */
export const STORE_HOST_HEADER = 'x-store-host';
